import { render, staticRenderFns } from "./StaffMember.vue?vue&type=template&id=030b311e&"
import script from "./StaffMember.vue?vue&type=script&lang=js&"
export * from "./StaffMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports